import { differenceInDays, startOfDay } from 'date-fns';

export default function daysBetweenDateAndStartOfWeek(d) {
  const weekStart = startOfDay(new Date());
  return differenceInDays(d, weekStart).toString();
}
